const INFO = {
	main: {
		title: "Kirunda Brian Portfolio",
		name: "Kirunda B.",
		email: "kirundab@gmail.com",
		logo: "../logo.jpg",
	},

	socials: {
		twitter: "https://x.com/kirundab",
		github: "https://github.com/Kirun1",
		linkedin: "https://www.linkedin.com/in/kirunda-brian-a30986139/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Full-stack web and mobile app developer, and tech enthusiast.",
		description:
			"I bridge vision and reality by crafting fast, scalable, and intuitive digital experiences. From pixel-perfect frontends to bulletproof backends, I specialize in turning complex requirements into seamless applications. Let’s build software that not only works flawlessly but also accelerates your business growth.",
	},

	about: {
		title: "Hey, I’m Kirunda – A Developer Building Solutions for Tomorrow’s Challenges.",
		description:
			"Based in Kampala, I architect digital experiences that solve real problems. With a blend of creativity and technical rigor, I’ve shipped products used by thousands—from open-source tools to enterprise applications. My code is public because I believe in transparency, collaboration, and pushing the boundaries of what’s possible. Let’s connect and build something meaningful together.",
	},

	articles: {
		title: "Sharing Insights to Build Better Tech – Together.",
		description:
			"Deep dives on modern development, leadership in tech, and the intersection of design and code. I break down complex topics into actionable insights—whether it’s optimizing React performance or leading remote engineering teams. Not just theory; every post is battle-tested from my own projects",
	},

	projects: [
		{
			title: "Kampala Eats - Food Delivery Platform",
			description: "Full-stack food ordering system serving 50+ restaurants in Kampala. Built with React, Node.js, and MongoDB. Reduced checkout time by 40% with optimized Firebase database rules and implemented real-time order tracking with Socket.io.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Case Study",
			link: "https://github.com/Kirun1/kampala-eats",
			techStack: ["React", "Node.js", "MongoDB", "Firebase", "Socket.io"]
		},
		{
			title: "FarmConnect - AgriTech Mobile App",
			description: "React Native app connecting 500+ Ugandan farmers with buyers. Implemented offline-first functionality with Redux Persist and image recognition for crop disease detection using TensorFlow.js. Achieved 92% accuracy in field tests across diverse crop varieties.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "App Demo",
			link: "https://github.com/Kirun1/farmconnect",
			techStack: ["React Native", "Redux", "TensorFlow.js", "Firebase"]
		},
		{
			title: "CodeCanvas - Developer Portfolio Builder",
			description: "Open-source Next.js template for technical portfolios. Features Markdown blog support, project showcases, and 98 Lighthouse performance score. Used by 1,200+ developers worldwide with 350+ GitHub stars.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "Use Template",
			link: "https://github.com/Kirun1/codecanvas",
			techStack: ["Next.js", "Tailwind CSS", "Markdown", "Vercel"]
		},
		{
			title: "HealthTrack - Clinic Management System",
			description: "HIPAA-compliant patient records system for 10+ Ugandan clinics. Built with Python/Django and PostgreSQL. Reduced patient processing time by 30% with automated form filling and implemented secure two-factor authentication.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View White Paper",
			link: "https://github.com/Kirun1/healthtrack",
			techStack: ["Django", "PostgreSQL", "Docker", "AWS"]
		},
		{
			title: "AirQ - Environmental Monitoring API",
			description: "REST API collecting air quality data from IoT sensors across Kampala. Processed 2M+ data points daily using Node.js and TimescaleDB. Implemented caching with Redis that reduced response times from 1200ms to 300ms.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "API Docs",
			link: "https://github.com/Kirun1/airq-api",
			techStack: ["Node.js", "TimescaleDB", "Redis", "Mapbox"]
		}
	]
};

export default INFO;
